var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"fm-thumbnail"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.src)?_c('i',{staticClass:"far fa-file-image fa-5x pb-2"}):_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.src,"alt":_vm.file.filename}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }